import checkmark from '@assets/images/coin-race/info/checkmark.png';
import clock from '@assets/images/coin-race/info/clock.png';
import com2checkmark from '@assets/images/coin-race/info/com2/com2checkmark.png';
import com2clock from '@assets/images/coin-race/info/com2/com2clock.png';
import com2points from '@assets/images/coin-race/info/com2/com2points.png';
import com2prize from '@assets/images/coin-race/info/com2/com2prize.png';
import points from '@assets/images/coin-race/info/points.png';
import prize from '@assets/images/coin-race/info/prize.png';

export const breakpointsConfig = {
	1300: {
		slidesPerView: 4
	},
	920: {
		slidesPerView: 3
	},
	680: {
		slidesPerView: 2
	},
	560: {
		slidesPerView: 1.5
	},
	0: {
		slidesPerView: 1.2
	}
};

const brandImages = {
	com2: {
		points: com2points,
		clock: com2clock,
		checkmark: com2checkmark,
		prize: com2prize
	},
	default: {
		points: points,
		clock: clock,
		checkmark: checkmark,
		prize: prize
	}
};

const getImageByBrand = (brand: string) => {
	return brandImages?.[brand as keyof typeof brandImages] || brandImages.default;
};

export const getInfoByBrand = (brand: string) => {
	return info(brand);
};

export const info = (brand: string) => [
	{
		title: 'info.points.title',
		description: 'info.points.description',
		image: getImageByBrand(brand).points
	},
	{
		title: 'info.duration.title',
		description: 'info.duration.description',
		image: getImageByBrand(brand).clock
	},
	{
		title: 'info.participation.title',
		description: 'info.participation.description',
		image: getImageByBrand(brand).checkmark
	},
	{
		title: 'info.prizes.title',
		description: 'info.prizes.description',
		image: getImageByBrand(brand).prize,
		attention: true
	}
];
